/* eslint-disable react-hooks/exhaustive-deps */
import { useCallback, useContext, useEffect, useRef, useState } from "react";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { useNavigate, useLocation, useParams, NavLink } from "react-router-dom";
import { empty, errorResponse, prepareResponseData } from "../../Utilities/utils";
import { AuthContext } from "../Root/ProtectedRoute";
import * as Yup from "yup";

// css
import "./Students.css";

// api
import studentApi from "../../api/Student";
import classApi from "../../api/Classes";

//components
import MainHeader from "../../components/headers/mainHeader/MainHeader";
import AppWrapper from "../../components/appWrapper/AppWrapper";
import { Toast } from "primereact/toast";
import StudentsTable from "../../components/tables/primeTable/students/StudentsTable";
import TableLoading from "../../components/skeleton/TableLoading";
import FullPageLoader from "../../components/loader/FullPageLoader";
import ButtonIcon from "../../components/buttons/buttonIcon/ButtonIcon";
import { Form, Formik } from "formik";
import SelectField from "../../components/form/SelectField";
import InputField from "../../components/form/InputField";
import { FaAngleDoubleRight, FaCloudUploadAlt, FaForward, FaPlus, FaWallet } from "react-icons/fa";
import { subscribeToJob } from "../../api/Csvapi";
import colors from "../../config/colors";

const required = "This field is required!";
const validationSchema = Yup.object().shape({
  classId: Yup.string().required(required),
  comment: Yup.string().optional(),
});

const initialValues = {
  classId: "",
  comment: "",
};

const Student = ({ ...props }) => {
  const { user } = useContext(AuthContext);
  const navigate = useNavigate();
  const getValues = useParams();
  const classId =
    !empty(getValues) && !empty(getValues.classId) ? getValues.classId : "";
  const isPromotionList =
    !empty(getValues) && !empty(getValues.promotion) ? true : false;
  const graduationYear =
    !empty(getValues) && !empty(getValues.graduationYear)
      ? getValues.graduationYear
      : "";
  const graduationClassTitle =
    !empty(getValues) && !empty(getValues.graduationClassTitle)
      ? getValues.graduationClassTitle
      : "";
  const graduationClassId =
    !empty(getValues) && !empty(getValues.graduationClassId)
      ? getValues.graduationClassId
      : "";
  const promotion =
    !empty(getValues) && !empty(getValues.promotion) ? getValues.promotion : "";
  const location = useLocation();
  //ref
  const toastTR = useRef(null);
  // states
  const [searchValue, setSearchValue] = useState("");
  const [filterValue, setFilterValue] = useState("");
  const [studentData, setStudentData] = useState([]);
  const [studentToToggleDialog, setStudentToToggleDialog] = useState(false);
  const [activationModalOpen, setActivationModalOpen] = useState(false);
  const [uploadCSVModalOpen, setUploadCSVModalOpen] = useState(false);
  const [promotionModalOpen, setPromotionModalOpen] = useState(false);
  const [selectedStudentDetail, setSelectedStudentDetail] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [totalRecords, setTotalRecords] = useState(0);
  const [first, setFirst] = useState(0);
  const [rows, setRows] = useState(50);
  const [search, setSearch] = useState("");
  const [isActionLoading, setIsActionLoading] = useState(false);
  const [showAddButton, setShowAddButton] = useState(false);
  const [selectedStudentIds, setSelectedStudentIds] = useState([]);
  const [studentIds, setStudentIds] = useState([]);
  const [classData, setClassData] = useState([]);
  const [classTitle, setClassTitle] = useState("");
  const [file, setFile] = useState(null);
  const [uploadProgress, setUploadProgress] = useState(0);
  const [job, setJob] = useState(null); // { jobId, status, processedRows, totalRows, successCount, failedCount }
  const [isDragging, setIsDragging] = useState(false);
  const eventSourceRef = useRef(null);
  const fileInputRef = useRef(null);
  
    useEffect(() => {
      // Close any open SSE connection when the component unmounts
      return () => eventSourceRef.current?.close();
    }, []);

  // check column
  const [checked, setChecked] = useState(false);

  //alert functions
  const responseDialog = (severity = null, summary = null, detail = null) => {
    toastTR?.current?.show({
      severity,
      summary,
      detail,
      life: 8000,
    });
  };

  useEffect(() => {
    setFirst(0);
  }, []);

  useEffect(() => {
    if (
      filterValue?.toLocaleLowerCase() === "active" ||
      filterValue?.toLocaleLowerCase() === "in-active"
    ) {
      getStudents();
    }
  }, [filterValue]);

  useEffect(() => {
    if (!empty(location) && !empty(location.state)) {
      const paramState = !empty(location.state) ? location.state : {};
      let studentAdded = !empty(paramState.studentAdded)
        ? paramState.studentAdded
        : false;
      let studentUpdated = !empty(paramState.studentUpdated)
        ? paramState.studentUpdated
        : false;
      let studentDeleted = !empty(paramState.studentDeleted)
        ? paramState.studentDeleted
        : false;
      if (
        studentAdded === true ||
        studentUpdated === true ||
        studentDeleted === true
      ) {
        const actionType = studentAdded
          ? "added"
          : studentUpdated
            ? "updated"
            : studentDeleted
              ? "deleted"
              : "";
        paramState.studentAdded = false;
        paramState.studentUpdated = false;
        paramState.studentDeleted = false;
        responseDialog(
          "success",
          "Success",
          `Student ${actionType} successfully!`,
        );
        if (!empty(location) && !empty(location.state)) {
          navigate(null, {
            replace: true,
            state: {
              studentAdded: false,
              studentUpdated: false,
              studentDeleted: false,
            },
          });
        }
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (isPromotionList) {
      getClasses();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isPromotionList]);

  useEffect(() => {
    const schoolId = !empty(user) && !empty(user._id) ? user._id : "";
    if (empty(schoolId)) return;
    setClassTitle("");
    try {
      getStudents();
      if (!empty(classId)) {
        getClassDetails();
      }
    } catch (error) {
      responseDialog("error", "Error Alert!", errorResponse(error));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user?._id, first, rows, classId, searchValue]);

  // function to get all classes
  const getClasses = async () => {
    try {
      const response = await classApi.getClasses('no');
      const response_data = prepareResponseData(response);
      if (empty(response_data) || !response_data.success) {
        return setClassData([]);
      } else {
        const data =
          !empty(response_data) && !empty(response_data.response)
            ? response_data.response
            : [];
        setClassData(data);
      }
    } catch (error) {}
  };

  const getClassDetails = async () => {
    try {
      const schoolId = !empty(user) && !empty(user._id) ? user._id : "";
      const response = await classApi.getSingleClass(classId, schoolId);
      const response_data = prepareResponseData(response);
      if (
        empty(response_data) ||
        empty(response_data) ||
        !response_data.response
      ) {
        return setClassTitle("");
      }
      const data =
        !empty(response_data) && !empty(response_data.response)
          ? response_data.response
          : {};
      const title = !empty(data) && !empty(data.title) ? data.title : "";
      return setClassTitle(title);
    } catch (error) {}
  };

  /**
   * Activate all students
   * @returns
   */
  const activateAllStudents = async () => {
    try {
      if (!isLoading) setIsLoading(true);
      const schoolId = !empty(user) && !empty(user._id) ? user._id : "";
      const response = await studentApi.activateAllStudent(schoolId, classId);
      const response_data = prepareResponseData(response);
      if (!response_data.success) {
        return responseDialog(
          "error",
          "Error Alert",
          `Failed to activate students.`,
        );
      }

      const _response = response_data?.response || {};
      const noOfActivatedStudents = _response?.noOfActivatedStudents || 0;
      const errorCountMessage =
        _response?.errorCount > 0
          ? `Activated ${noOfActivatedStudents} student(s), but failed to update ${_response.errorCount} student(s). You have exhausted your available credit.`
          : "";
      const warningMessage =
        _response?.alreadyActivatedCount > 0
          ? `Activated ${noOfActivatedStudents} student(s), but failed to activate ${_response.alreadyActivatedCount} student(s). Student(s) already activated previously`
          : "";

      if (!empty(errorCountMessage)) {
        responseDialog("warn", "Credit Exhausted", errorCountMessage);
        return setTimeout(() => {
          window.location.reload();
        }, 5000);
      }
      if (!empty(warningMessage)) {
        responseDialog("warn", "Partial Activation", warningMessage);
        return setTimeout(() => {
          window.location.reload();
        }, 5000);
      }

      responseDialog("success", "Success", "Activated students successfully.");
      return setTimeout(() => {
        window.location.reload();
      }, 2000);
    } catch (error) {
      responseDialog("error", "Error Alert!", errorResponse(error));
    } finally {
      setIsLoading(false);
    }
  };

  // function to get all student
  const getStudents = async () => {
    try {
      if (!isLoading) setIsLoading(true);
      const schoolId = !empty(user) && !empty(user._id) ? user._id : "";
      const page = first / rows;
      let response;
      if (!empty(classId)) {
        response = await studentApi.getStudentsInClass(
          schoolId,
          page,
          rows,
          searchValue,
          classId,
          "list",
          filterValue,
        );
      } else if (!empty(graduationClassId) && !empty(graduationYear)) {
        response = await studentApi.getStudentsByGraduationYear(
          schoolId,
          graduationYear,
          graduationClassId,
          "list",
        );
      } else {
        response = await studentApi.getStudents(
          schoolId,
          page,
          rows,
          searchValue,
          "list",
          filterValue,
        );
      }
      const response_data = prepareResponseData(response);
      if (empty(response_data) || !response_data.success) {
        return setStudentData([]);
      } else {
        const results =
          !empty(response_data) && !empty(response_data.response)
            ? response_data.response
            : [];
        setStudentData(results);
        setTotalRecords(!empty(response_data.count) ? response_data.count : 0);
        const _studentIds = [];
        for (let i = 0; i < results.length; i++) {
          const id =
            !empty(results[i]) && !empty(results[i]._id) ? results[i]._id : "";
          if (!isPromotionList) {
            const paid =
              !empty(results[i]) &&
              !empty(results[i].paid) &&
              results[i].paid === "Yes"
                ? true
                : false;
            const active =
              !empty(results[i]) &&
              !empty(results[i].active) &&
              results[i].active
                ? true
                : false;
            if (!paid && active) {
              _studentIds.push(id);
            }
          } else {
            _studentIds.push(id);
          }
        }
        setStudentIds(_studentIds);
      }
    } catch (error) {
      responseDialog("error", "Error Alert!", errorResponse(error));
    } finally {
      setIsLoading(false);
    }
  };

  //function to toggle student visibility
  const toggleStudentVisibility = async () => {
    try {
      if (studentToToggleDialog) setStudentToToggleDialog(false);
      if (!isActionLoading) setIsActionLoading(true);
      const schoolId = !empty(user) && !empty(user._id) ? user._id : "";
      const active =
        !empty(selectedStudentDetail) && !empty(selectedStudentDetail.active)
          ? "Yes"
          : "No";
      const studentId =
        !empty(selectedStudentDetail) && !empty(selectedStudentDetail._id)
          ? selectedStudentDetail._id
          : "";
      const response = await studentApi.toggleStudentVisibility(
        studentId,
        active,
        schoolId,
      );
      const response_data = prepareResponseData(response);
      if (empty(response_data) || !response_data.success) {
        const error_response =
          !empty(response_data) && !empty(response_data.response)
            ? response_data.response
            : `Failed to ${
                !empty(selectedStudentDetail) &&
                !empty(selectedStudentDetail.active) &&
                selectedStudentDetail.active === false
                  ? "enable"
                  : "disable"
              } student with name, ${
                !empty(selectedStudentDetail.lastName) &&
                !empty(selectedStudentDetail.firstName)
                  ? `${selectedStudentDetail.lastName} ${selectedStudentDetail.firstName}`
                  : ""
              }`;
        return responseDialog("error", "Something went wrong1", error_response);
      }

      responseDialog(
        "success",
        "Success",
        `Student, ${
          !empty(selectedStudentDetail.lastName) &&
          !empty(selectedStudentDetail.firstName)
            ? `${selectedStudentDetail.lastName} ${selectedStudentDetail.firstName}`
            : ""
        }, was ${
          !empty(selectedStudentDetail) &&
          !empty(selectedStudentDetail.active) &&
          selectedStudentDetail.active === true
            ? "disabled"
            : "enabled"
        } successfully!`,
      );
      return getStudents();
    } catch (error) {
      responseDialog("error", "Error Alert!", errorResponse(error));
    } finally {
      setIsActionLoading(false);
    }
  };

  //function to activate student on payment
  const activateStudent = async (studentIds) => {
    try {
      if (activationModalOpen) setActivationModalOpen(false);
      if (!isActionLoading) setIsActionLoading(true);
      if (empty(studentIds)) {
        return responseDialog(
          "error",
          "Error Alert",
          "There are no selected students.",
        );
      }
      const schoolId = !empty(user) && !empty(user._id) ? user._id : "";
      const response = await studentApi.activateStudent(studentIds, schoolId);
      const response_data = prepareResponseData(response);
      const tag = `${studentIds.length > 0 ? "students" : "student"}`;
      if (empty(response_data) || !response_data.success) {
        const error_response =
          !empty(response_data) && !empty(response_data.response)
            ? response_data.response
            : `Failed to activate ${tag}`;
        return responseDialog("error", "Error Alert", error_response);
      }

      const _response = response_data?.response || {};
      const noOfActivatedStudents = _response?.noOfActivatedStudents || 0;
      const errorCountMessage =
        _response?.errorCount > 0
          ? `Activated ${noOfActivatedStudents} student(s), and failed to activate ${_response.errorCount} student(s). You have exhausted your available credit.`
          : "";
      const warningMessage =
        _response?.alreadyActivatedCount > 0
          ? `Activated ${noOfActivatedStudents} student(s), and failed to activate ${_response.alreadyActivatedCount} student(s). Student(s) already activated previously`
          : "";

      setSelectedStudentIds([]);
      setShowAddButton(false);
      if (!empty(errorCountMessage)) {
        responseDialog("warn", "Credit Exhausted", errorCountMessage);
        return setTimeout(() => {
          window.location.reload();
        }, 5000);
      }
      if (!empty(warningMessage)) {
        responseDialog("warn", "Partial Activation", warningMessage);
        return setTimeout(() => {
          window.location.reload();
        }, 5000);
      }

      responseDialog("success", "Success", `Activated ${tag} successfully!`);
      return setTimeout(() => {
        window.location.reload();
      }, 2000);
    } catch (error) {
      responseDialog("error", "Error Alert!", errorResponse(error));
    } finally {
      setIsActionLoading(false);
    }
  };

  //function to show confirm modal
  const showDisableConfirm = (data) => {
    setSelectedStudentDetail(data);
    setStudentToToggleDialog(true);
  };

  //function to hide confirm modal
  const hideDisableStudentDialog = () => {
    setStudentToToggleDialog(false);
  };

  // open activation modal
  const showActivationModal = (data = {}, type = "") => {
    if (!empty(selectedStudentDetail)) setSelectedStudentDetail({});
    if (type === "single") {
      const id = !empty(data) && !empty(data._id) ? data._id : "";
      setSelectedStudentIds([id]);
      setSelectedStudentDetail(data);
    }
    setActivationModalOpen(true);
  };
  // hide activation modal
  const hideActivationModal = () => {
    setActivationModalOpen(false);
  };
  // hide csv upload modal
  const hideCSVUploadModal = () => {
    setUploadCSVModalOpen(false);
  };

  //go to update student page
  const gotToUpdateStudent = (data) => {
    const studentId = !empty(data) && !empty(data._id) ? data._id : "";
    navigate(`/student/${studentId}/update`);
  };

  const onKeyDown = (event) => {
    if (event.key === "Enter") {
      setSearchValue(event.target.value);
      setFirst(0);
    }
  };

  const onSearchChange = (event) => {
    setSearch(event.target.value);
  };

  const updateSelectedStudentIds = useCallback((studentId) => {
    if (!studentId) return;

    setSelectedStudentIds((prev) => {
      const exists = prev.includes(studentId);
      const newSelection = exists
        ? prev.filter((id) => id !== studentId)
        : [...prev, studentId];

      setShowAddButton(newSelection.length > 0);
      // setChecked(newSelection.length === totalRecords && totalRecords > 0);

      return newSelection;
    });
  }, []);

  const handleFileChange = (e) => {
    setFile(e.target.files[0] || null);
    setJob(null);
    setUploadProgress(0);
  };

  const pickFile = (picked) => {
    if (!picked) return;
    if (!picked.name.toLowerCase().endsWith('.csv')) {
      responseDialog("error", "Error Alert!", 'Please choose a .csv file.');
      return;
    }
    setFile(picked);
    setJob(null);
    setUploadProgress(0);
  };

  const handleDrop = (e) => {
    e.preventDefault();
    setIsDragging(false);
    pickFile(e.dataTransfer.files?.[0]);
  };

  /**
   * Upload csv file
   */
  const handleUpload = useCallback(async () => {
    if (!file) return;
    if (!isActionLoading) setIsActionLoading(true);

    setUploadProgress(0);
    setJob({ status: 'uploading' });

    try {
      const { response } = await uploadCsv(file, setUploadProgress);
      if (!response?.success) {
        responseDialog("success", "Processing!", response?.message || "The process is running on the background. You can continue with other tasks and you will be notified when the process completes.");
      }
      hideCSVUploadModal();

      setJob({ jobId: response.jobId, status: 'queued', processedRows: 0, totalRows: 0 });

      eventSourceRef.current?.close();
      eventSourceRef.current = subscribeToJob(response.jobId, {
        onProgress: (payload) => setJob((prev) => ({ ...prev, ...payload, status: payload.status || 'processing' })),
        onDone: (payload) => {
          setJob((prev) => ({ ...prev, ...payload, status: payload.status }));
          responseDialog(payload?.status === 'completed' ? "success" : "error", payload?.status === 'completed' ? "Uploaded Successfully" : "Error Alert!", (
            payload.status === 'completed'
              ? `Import complete: ${ payload?.successCount || 'N/A number of' } rows loaded${payload?.failedCount ? `; ${payload.failedCount} failed.` : '.'}`
              : `Import finished with errors (${ payload?.failedCount || 'N/A number of'} failed).`
          ));
          eventSourceRef.current?.close();
        },
        onError: (payload) => {
          if (payload.transient) return; // EventSource is auto-retrying, don't alarm the user yet
          responseDialog("error", "Error Alert!", `Import failed: ${payload?.message || 'Something went wrong.'}`);
          setJob((prev) => ({ ...prev, status: 'failed' }));
        },
      });
    } catch (error) {
      responseDialog("error", "Error Alert!", errorResponse(error));
      setJob(null);
    } finally {
      setIsActionLoading(false);
    }
  }, [file]);

  const isUploading = job?.status === 'uploading';
  const isProcessing = job && ['queued', 'processing'].includes(job.status);
  const percentDone =
    job?.totalRows > 0 ? Math.round((job.processedRows / job.totalRows) * 100) : null;

  // upload students via csv 
  const uploadCsv = async (file, onUploadProgress) => {
    try {
      const form = new FormData();
      form.append('file', file);

      const response = await studentApi.uploadStudentsCsv(form, onUploadProgress);
      const response_data = prepareResponseData(response);
      return response_data;

    } catch (error) {
      responseDialog("error", "Error Alert!", errorResponse(error));
    }
  }

  const disableStudentDialogFooter = (
    <div
      style={{
        marginTop: 20,
      }}
    >
      <Button
        label="No"
        icon="pi pi-times"
        style={{
          backgroundColor: "transparent",
          color: colors.danger,
          borderColor: colors.danger,
          borderWidth: 1,
        }}
        onClick={hideDisableStudentDialog}
      />
      <Button
        label="Yes"
        icon="pi pi-check"
        style={{
          backgroundColor: "transparent",
          color: colors.success,
          borderColor: colors.success,
          borderWidth: 1,
        }}
        onClick={toggleStudentVisibility}
      />
    </div>
  );

  const activateStudentDialogFooter = (
    <div
      style={{
        marginTop: 20,
      }}
    >
      <Button
        label="No"
        icon="pi pi-times"
        style={{
          backgroundColor: "transparent",
          color: colors.danger,
          borderColor: colors.danger,
          borderWidth: 1,
        }}
        onClick={hideActivationModal}
      />
      <Button
        label="Yes"
        icon="pi pi-check"
        style={{
          backgroundColor: "transparent",
          color: colors.success,
          borderColor: colors.success,
          borderWidth: 1,
        }}
        onClick={() => {
          activateStudent(selectedStudentIds);
        }}
      />
    </div>
  );

  const uploadCSVDialogFooter = (
    <div
      style={{
        marginTop: 20,
      }}
    >
      <Button
        label="Cancel"
        icon="pi pi-times"
        style={{
          backgroundColor: "transparent",
          color: colors.danger,
          borderColor: colors.danger,
          borderWidth: 1,
        }}
        onClick={() => hideCSVUploadModal}
      />
      <Button        
        label="Upload Students"
        icon="pi pi-check"
        style={{
          backgroundColor: "transparent",
          color: colors.success,
          borderColor: colors.success,
          borderWidth: 1,
        }}
        onClick={() => {
          handleUpload();
        }}
      />
    </div>
  );

  const onPageChange = (event) => {
    setFirst(event.first);
    setRows(event.rows);
  };

  // open promotion modal
  const showPromotionModal = (data = {}, type = "") => {
    if (!empty(selectedStudentDetail)) setSelectedStudentDetail({});
    if (type === "single") {
      const id = !empty(data) && !empty(data._id) ? data._id : "";
      setSelectedStudentIds([id]);
      setSelectedStudentDetail(data);
    }
    setPromotionModalOpen(true);
  };

  // hide activation modal
  const hidePromotionModal = () => {
    setPromotionModalOpen(false);
  };

  // filter search
  const filterSearch = (value) => {
    setFilterValue(value);
  };

  // promote students
  const handleSubmit = async (values) => {
    try {
      if (promotionModalOpen) setPromotionModalOpen(false);
      if (!isActionLoading) setIsActionLoading(true);
      if (empty(studentIds)) {
        return responseDialog(
          "error",
          "Error Alert",
          "There are no selected students.",
        );
      }
      const comment =
        !empty(values) && !empty(values.comment) ? values.comment : "";
      const _classId =
        !empty(values) && !empty(values.classId) ? values.classId : "";
      const schoolId = !empty(user) && !empty(user._id) ? user._id : "";
      const response = await studentApi.promoteStudent(
        selectedStudentIds,
        schoolId,
        comment,
        _classId,
        classId,
      );
      const response_data = prepareResponseData(response);
      const tag = `${selectedStudentIds.length > 0 ? "students" : "student"}`;
      if (empty(response_data) || !response_data.success) {
        const error_response =
          !empty(response_data) && !empty(response_data.response)
            ? response_data.response
            : `Failed to promote the selected ${tag}`;
        return responseDialog("error", "Error Alert", error_response);
      }

      responseDialog("success", "Success", `Promoted ${tag} successfully!`);
      setSelectedStudentIds([]);
      setShowAddButton(false);
      return getStudents();
    } catch (error) {
      responseDialog("error", "Error Alert!", errorResponse(error));
    } finally {
      setIsActionLoading(false);
    }
  };

  const uploadCVResult = async () => {
    setUploadCSVModalOpen(true);
  }

  return (
    <>
      <AppWrapper {...props}>
        <main>
          <div className="tableCard">
            {/*  header start */}
            <MainHeader
              button={
                empty(graduationClassId) || empty(graduationYear) ? true : false
              }
              multiButtons={
                <>
                  {empty(classId) &&
                    empty(graduationClassId) &&
                    empty(graduationYear) && (
                      <>
                        <NavLink
                          to="/student/add"
                          style={{ textDecoration: "none" }}
                        >
                          <ButtonIcon
                            borderColor={colors.primary}
                            backgroundColor={colors.primary}
                            color={colors.white}
                            buttonText="Add Students"
                            marginRight={1}
                            iconMarginRight={5}
                            icon={<FaPlus />}
                            width={140}
                            height={30}
                            marginBottom={2}
                          />
                        </NavLink>
                        <ButtonIcon
                          borderColor={colors.primary}
                          backgroundColor={colors.primary}
                          color="#ffffff"
                          buttonText="Upload Students"
                          width={170}
                          iconMarginRight={5}
                          icon={<FaCloudUploadAlt />}
                          height={30}
                          marginBottom={2}
                          onClick={() => uploadCVResult()}
                        />
                      </>
                    )}
                  <ButtonIcon
                    borderColor={colors.primary}
                    backgroundColor={colors.primary}
                    color="#ffffff"
                    buttonText="Activate Active Students"
                    width={220}
                    iconMarginRight={5}
                    marginRight={1}
                    marginLeft={1}
                    icon={<FaWallet />}
                    height={30}
                    marginBottom={2}
                    onClick={() => activateAllStudents()}
                  />
                  {/* {showAddButton && !isPromotionList && (
                    <ButtonIcon
                      borderColor={colors.primary}
                      backgroundColor={colors.primary}
                      color="#ffffff"
                      buttonText="Activate All Students"
                      marginRight={1}
                      width={170}
                      height={30}
                      marginBottom={2}
                      onClick={() => showActivationModal()}
                    />
                  )}  */}
                  {showAddButton && isPromotionList && (
                      <ButtonIcon
                        borderColor={colors.primary}
                        backgroundColor={colors.primary}
                        color="#ffffff"
                        buttonText="Promote Students"
                        marginRight={1}
                        icon={<FaForward />}
                        width={190}
                        height={30}
                        iconMarginRight={8}
                        marginBottom={2}
                        onClick={() => showPromotionModal()}
                      />
                  )}
                </>
              }
              title={
                !empty(classTitle)
                  ? "Students in " + classTitle
                  : !empty(graduationClassId) && !empty(graduationYear)
                    ? `${graduationYear} ${graduationClassTitle} Graduands`
                    : `Students`
              }
            />
            {isUploading && (
            <ProgressBar percent={uploadProgress} label={`Uploading file… ${uploadProgress}%`} />
          )}

          {job && job.status !== 'uploading' && (
            <div style={styles.jobBox}>
              <StatusBadge status={job.status} />
              {job.status === 'processing' || job.status === 'queued' ? (
                <>
                  <ProgressBar
                    percent={percentDone ?? 0}
                    indeterminate={percentDone === null}
                    label={
                      job.totalRows
                        ? `Processing rows: ${job.processedRows} / ${job.totalRows}`
                        : 'Processing… (counting rows)'
                    }
                  />
                  <p style={styles.hint}>
                    You can keep using the app — this keeps running in the background and will notify you when it's done.
                  </p>
                </>
              ) : (
                <p className="flex align-center" style={styles.summary}>
                  <FaAngleDoubleRight />&nbsp;&nbsp;<span>{job.status === 'completed'
                    ? `${job.successCount ?? 0} rows imported${job.failedCount ? `, ${job.failedCount} failed` : ''}.`
                    : `Import ${job.status}. ${job.failedCount ? `${job.failedCount} rows failed.` : ''}`}</span>
                </p>
              )}
            </div>
          )}
            {/* end of header */}

            {/* table start */}
            {!isLoading ? (
              <StudentsTable
                key={selectedStudentIds.join(",")}
                students={studentData}
                confirmDisableSelected={showDisableConfirm}
                goToUpdateStudentScreen={gotToUpdateStudent}
                onPageChange={onPageChange}
                rows={rows}
                totalRecords={totalRecords}
                first={first}
                search={search}
                onKeyDown={onKeyDown}
                isClassList={!empty(classId)}
                onSearchChange={onSearchChange}
                goToActivateStudent={(data) =>
                  showActivationModal(data, "single")
                }
                promoteStudent={(data) => showPromotionModal(data, "single")}
                setChecked={setChecked}
                setShowAddButton={setShowAddButton}
                showAddButton={showAddButton}
                checked={checked}
                setSelectedStudentIds={setSelectedStudentIds}
                selectedStudentIds={selectedStudentIds}
                updateSelectedStudentIds={updateSelectedStudentIds}
                studentIds={studentIds}
                isPromotionList={!empty(promotion)}
                activateEmpty={empty(studentIds)}
                graduationList={
                  !empty(graduationClassId) && !empty(graduationYear)
                    ? true
                    : false
                }
                filterValue={filterValue?.toLowerCase() === "in-active" ? 2 : 1}
                filterSearch={filterSearch}
              />
            ) : (
              <TableLoading rows={50} cols={7} header={false} />
            )}
            {/* table end  */}
          </div>
        </main>
        {isActionLoading && <FullPageLoader visible={isActionLoading} />}
      </AppWrapper>

      <Dialog
        visible={studentToToggleDialog}
        style={{ width: "32rem", zIndex: 999999 }}
        breakpoints={{ "960px": "75vw", "641px": "90vw" }}
        header="Confirm"
        modal
        footer={disableStudentDialogFooter}
        onHide={hideDisableStudentDialog}
      >
        <div
          className="confirmation-content"
          style={{ marginTop: 20, display: "flex", alignItems: "center" }}
        >
          <i
            className="pi pi-exclamation-triangle mr-3"
            style={{ fontSize: "2rem", marginRight: 15, color: colors.danger }}
          />
          {
            <span>
              Are you sure you want to{" "}
              {!empty(selectedStudentDetail) &&
              !empty(selectedStudentDetail.active) &&
              selectedStudentDetail.active ? (
                <span style={{ color: "red" }}>
                  <strong>disable</strong>
                </span>
              ) : (
                <span style={{ color: "green" }}>
                  <strong>enable</strong>
                </span>
              )}{" "}
              the selected student -{" "}
              <strong>
                {!empty(selectedStudentDetail) &&
                !empty(selectedStudentDetail.title)
                  ? selectedStudentDetail.title
                  : ""}
              </strong>
              {selectedStudentDetail && (
                <b>
                  {!empty(selectedStudentDetail.name)
                    ? selectedStudentDetail.name
                    : ""}
                </b>
              )}
              ?
            </span>
          }
        </div>
      </Dialog>

      {/* Upload students via CSV */}
      <Dialog
        visible={uploadCSVModalOpen}
        style={{ width: "32rem", zIndex: 999999 }}
        breakpoints={{ "960px": "75vw", "641px": "90vw" }}
        header="Upload Students"
        modal
        footer={file?.name ? uploadCSVDialogFooter : <span></span>}
        onHide={hideCSVUploadModal}
      >
        <div
          className="confirmation-content flex direction-column align-center justify-center mt-20 mb-20"
        >
          <FaCloudUploadAlt
            size={150}
            tabIndex={0}
            onClick={() => !(isUploading || isProcessing) && fileInputRef.current?.click()}
            onKeyDown={(e) => {
              if ((e.key === 'Enter' || e.key === ' ') && !(isUploading || isProcessing)) {
                e.preventDefault();
                fileInputRef.current?.click();
              }
            }}
            onDragOver={(e) => {
              e.preventDefault();
              if (!(isUploading || isProcessing)) setIsDragging(true);
            }}
            onDragLeave={() => setIsDragging(false)}
            onDrop={handleDrop}
            style={{
              cursor: "pointer",
              ...styles.dropzone,
              ...(isDragging ? styles.dropzoneActive : {}),
              ...((isUploading || isProcessing) ? styles.dropzoneDisabled : {}),
            }}
        />
          {
            file?.name || ''
          }
        </div>
        <div className="flex direction-column align-center">
          <span className="mb-5">Click the icon above to upload file.</span>
          <span><strong className="text-red">Note:</strong> CSV is the only acceptable format.</span>
        </div>
        <input type="file" ref={fileInputRef} accept=".csv" onChange={handleFileChange} hidden/>
      </Dialog>
 
      <Dialog
        visible={activationModalOpen}
        style={{ width: "32rem", zIndex: 999999 }}
        breakpoints={{ "960px": "75vw", "641px": "90vw" }}
        header="Confirm"
        modal
        footer={activateStudentDialogFooter}
        onHide={hideActivationModal}
      >
        <div
          className="confirmation-content"
          style={{ marginTop: 20, display: "flex", alignItems: "center" }}
        >
          <i
            className="pi pi-exclamation-triangle mr-3"
            style={{ fontSize: "2rem", marginRight: 15, color: colors.danger }}
          />
          {
            <>
              <p>
                Are you sure you want to <strong>activate</strong> this student?{" "}
                <br />
                <br />
                By clicking "Yes", you are confirming that{" "}
                <strong>
                  {!empty(selectedStudentDetail) &&
                  !empty(selectedStudentDetail.firstName) &&
                  !empty(selectedStudentDetail.lastName)
                    ? selectedStudentDetail.lastName +
                      " " +
                      selectedStudentDetail.firstName +
                      " has"
                    : "the selected students have"}
                </strong>{" "}
                made portal payment for this term.
                <br />
                <br />
                <em style={{ color: colors.danger }}>
                  <strong>Note:</strong> This action cannot be undone.
                </em>
              </p>
            </>
          }
        </div>
      </Dialog>

      <Dialog
        visible={promotionModalOpen}
        className="promotion-modal"
        breakpoints={{ "960px": "75vw", "641px": "90vw" }}
        header="Confirm Promotion"
        modal
        onHide={hidePromotionModal}
      >
        <div
          className="confirmation-content"
          style={{ display: "flex", alignItems: "center" }}
        >
          {
            <>
              <div className="form-container">
                <div>
                  <p>
                    <strong>Current Class:</strong> {classTitle}
                  </p>
                  <br></br>
                  <p className="flex align-center">
                    You are about to promote the selected student(s). Ensure
                    that you are promoting the right students to the right
                    class.
                  </p>
                </div>
                <Formik
                  enableReinitialize
                  initialValues={initialValues}
                  validationSchema={validationSchema}
                  onSubmit={handleSubmit}
                >
                  {({ values, handleChange }) => (
                    <Form style={{ width: "100%" }}>
                      <div
                        style={{
                          width: "50%",
                          display: "flex",
                          columnGap: 12,
                        }}
                      >
                        <SelectField
                          labelTitle="Promote to"
                          placeholder="Select class"
                          name="classId"
                          required={true}
                          options={classData}
                          height={50}
                          valueKey="id"
                          selectedOption={values.classId}
                          handleChangeFunc={handleChange}
                          customPlaceholder="Graduated"
                          customValue="graduated"
                        />
                      </div>
                      <div
                        style={{
                          width: "100%",
                          display: "flex",
                          columnGap: 12,
                          alignItems: "center",
                          marginBottom: 12,
                        }}
                      >
                        <InputField
                          placeholder="Enter Comment"
                          name="comment"
                          height={180}
                          as="textarea"
                          row={9}
                          cols={8}
                          labelTitle="Comment"
                        />
                      </div>
                      <div
                        style={{
                          width: "100%",
                          display: "flex",
                          justifyContent: "center",
                        }}
                      >
                        <ButtonIcon
                          height={45}
                          marginTop={5}
                          color="#ffffff"
                          backgroundColor="#633ccd"
                          width={300}
                          borderColor="#633ccd"
                          buttonText="Promote"
                          type="submit"
                        />
                      </div>
                    </Form>
                  )}
                </Formik>
              </div>
            </>
          }
        </div>
      </Dialog>
      <Toast ref={toastTR} style={{ zIndex: 99999 }} position="bottom-left" />
    </>
  );
};


function StatusBadge({ status }) {
  const labels = {
    queued: 'Queued',
    processing: 'Processing',
    completed: 'Completed',
    failed: 'Failed',
  };
  const _colors = {
    queued: colors.gray,
    processing: colors.primary,
    completed: colors.success,
    failed: colors.danger,
  };
  return (
    <span style={{ ...styles.badge, backgroundColor: _colors[status] || colors.gray }}>
      {labels[status] || status}
    </span>
  );
}

function ProgressBar({ percent, label, indeterminate }) {
  return (
    <div style={styles.progressWrap}>
      {label && <div style={styles.progressLabel}>{label}</div>}
      <div style={styles.progressTrack}>
        <div
          style={{
            ...styles.progressFill,
            width: indeterminate ? '40%' : `${Math.min(100, Math.max(0, percent))}%`,
            animation: indeterminate ? 'csv-indeterminate 1.2s infinite ease-in-out' : 'none',
          }}
        />
      </div>
      <style>{`
        @keyframes csv-indeterminate {
          0% { margin-left: -40%; }
          100% { margin-left: 100%; }
        }
      `}</style>
    </div>
  );
}

const styles = {
  jobBox: { marginTop: 16 },
  badge: { display: 'inline-block', color: colors.white, fontSize: 12, padding: '2px 8px', borderRadius: 12, marginBottom: 8 },
  progressWrap: { marginTop: 10 },
  progressLabel: { fontSize: 13, color: colors.lightAsh, marginBottom: 4 },
  progressTrack: { background: colors.white, borderRadius: 6, height: 8, overflow: 'hidden' },
  progressFill: { background: colors.primary, height: '100%', borderRadius: 6, transition: 'width 0.3s ease' },
  hint: { fontSize: 12, color: colors.lightAsh, marginTop: 8 },
  summary: { fontSize: 14, color: colors.black },
  dropzone: {
    position: 'relative',
    border: '2px dashed #cbd5e1',
    borderRadius: 8,
    padding: '24px 16px',
    textAlign: 'center',
    cursor: 'pointer',
    background: '#f8fafc',
    marginBottom: 12,
  },
  dropzoneActive: { borderColor: '#2563eb', background: '#eff6ff' },
  dropzoneDisabled: { cursor: 'not-allowed', opacity: 0.6 },
  dropzoneText: { fontSize: 14, color: '#475569' },
};

export default Student;
